<template>
  <div v-if="!note_id" class="medical-history"><p>상담건이 없습니다.</p></div>
  <div v-else class="medical-history" :note_id="note_id">
    <!-- 상담 신청 내용 -->
    <div class="history-cont">
        <h3>처방 내역
          <button v-if="note_status<=3" type="button" class="btn-cancel" @click="sendCancel()">접수취소</button>
          <button  v-if="account.is_admin && note.pharmacy_status == 3" type="button" class="btn-confirm" @click="forcePayment()">결제완료</button>
        </h3>
        <div class="guest-info">
          <dl>
            <dt>고객명</dt>
            <dd>
              {{ note.uname ? note.uname : '-'  }} 
              <span class="signup-notice-red">(인증완료)</span>
            </dd>
            <dt>조제대상자명</dt>
            <dd v-if="note.consult_user_type==1">
              <span>{{note.consult_user_name ? note.consult_user_name + '(본인)' : '-'}}</span>
            </dd>
            <dd v-else>
              <span>{{ note.consult_user_name }} ( {{ note.consult_user_type ? get_user_type(note.consult_user_type) : '-'  }}  )</span>
            </dd>
            <dt>주민번호</dt>
            <dd>
              <span>{{ note.consult_user_no | personal_no_format }}</span>
            </dd>
            <dt>전화번호</dt>
            <dd>
              <span>{{ note.tel_no | phone_format }}</span>
            </dd>
            <dt>주소</dt>
            <dd>
              <span>{{ '[' + note.post_code + ']' }} {{ note.address }} {{ note.address_detail }}</span>
            </dd>            
            <dt>병원명/원장</dt>
            <dd>
              <span>{{ note.dr_name }} / {{ note.hosp_dr_name }} ({{ note.hosp_contact ? note.hosp_contact : '전화번호없음' }})</span>
            </dd>
            <dt>처방전</dt>
            <dd>
              <span></span>
            </dd>
          </dl>
        </div>
        <div v-if="info_on" class="guest-info">
          <dl>   
            <dt>복용중인 약</dt>
            <dd>{{ note.taking_medicine }}</dd>
            <dt>알러지 유무</dt>
            <dd>{{ note.is_allergy==1 ? '예':'아니오' }}</dd>
          </dl>
        </div>
        <div v-if="info_on" class="guest-info-l">
          <dl>   
            <dt v-if="note.is_allergy==1">알러지 유발 음식/약/환경</dt>
            <dd v-if="note.is_allergy==1"></dd>
            <div v-if="note.is_allergy==1" class="history-txt"><div v-html="note.allergy_contents"></div></div>
            <dt v-if="note.is_allergy==1">알러지 반응</dt>
            <dd v-if="note.is_allergy==1"></dd>
            <div v-if="note.is_allergy==1" class="history-txt"><div v-html="note.allergy_reaction_name"></div></div>
            <dt>가족 병력</dt>
            <dd></dd>
            <div class="history-txt"><div v-html="note.fhx"></div></div>
            <dt>기타</dt>
            <dd></dd>
            <div v-if="info_on" class="history-txt"><div v-html="note.comment"></div></div>
          </dl>
        </div>
    </div>
    <div v-if="info_on" class="history-client">
        <h3>고객정보 
          <button v-if="Object.keys(this.user).length > 0 && !user_on" class="etc-btn" @click="viewUserInfo()">펼치기</button>
          <button v-if="Object.keys(this.user).length > 0 && user_on" class="etc-btn" @click="viewUserInfo()">접기</button>
        </h3>
        <div class="guest-info">
          <dl class="name-info">
            <dt>이름</dt>
            <dd>
            <span v-if="note_status==0 || note_status==9">{{note.name ? note.name.substr(0,1) + '**' : '-'}}</span>
            <span v-else>{{ note.name }}</span>
            </dd>
            <dt>국가</dt>
            <dd style="font:400 11px Noto Sans KR,sans-serif;">{{ note.user_nation }}{{ note.address_1 ? '/'+ note.address_1 : ''}}</dd>
            <dt>OS타입</dt>
            <dd>{{ note.os_type==1 ? '안드로이드' : '아이폰' }}</dd>
            </dl>
        </div>
        <div v-if="user_on" class="guest-info">
          <dl class="data-info" v-if="Object.keys(this.user).length > 0">
            <dt>생년월일</dt>
            <dd>{{ this.user.birthday | date_format('YYYY-MM-DD') }}</dd>
            <dt>신장</dt>
            <dd>{{ this.user.height }}</dd>
            <dt>흡연여부</dt>
            <dd>{{ smoking_text(this.user.is_smoking) }}</dd>
          </dl>
          <dl class="data-info" v-if="Object.keys(this.user).length > 0">
            <dt>성별</dt>
            <dd>{{ gender_text(this.user.sex) }}</dd>
            <dt>체중</dt>
            <dd>{{ this.user.weight }}</dd>
            <dt>음주여부</dt>
            <dd>{{ drinking_text(this.user.is_drinking) }}</dd>
          </dl>
        </div>
        <div v-if="user_on" class="guest-info">
          <dl v-if="Object.keys(this.user).length > 0">
            <dt>본인병력</dt>
            <dd>{{ this.user.hx }}</dd>
            <dt>가족력</dt>
            <dd>{{ this.user.fhx }}</dd>
            <dt>복약여부</dt>
            <dd>{{ this.user.medication }}</dd>
          </dl>
        </div>      
    </div>

    <!-- 처방전, 계산서/추가서류 탭 -->
    <div class="box">
      <!-- 처방전 -->
      <div class="history-client">
        <!-- <h2>처방전</h2> -->
        <div class="answer" v-for="(reply, index) in replies" :key="index">
          <div id='page'>
              <div id="subpage" v-if="reply.img_url && reply.img_url.includes('pdf')" class="thumbnail" @click="pdf_click(reply.img_url)">
                <!-- <pdf :src="reply.img_url" alt=""></pdf> -->
                <img src="../../assets/images/sample_pdf.jpg" alt="">
              </div>
              <div id="subpage" v-else-if="reply.img_url && !reply.img_url.includes('pdf')" class="thumbnail" @click="img_click(reply.img_url)">
                <!-- <img id="img-url" :src="reply.img_url" alt=""> -->
                <img src="../../assets/images/sample_pdf.jpg" alt="">
              </div>
              <!-- <button type="button" class="btn-submit" @click="print">출력</button> -->
              <button type="button" class="btn-submit" v-if="reply.img_url && !reply.img_url.includes('pdf')" @click="print">출력</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import moment from 'moment-timezone';
  import URLS from '@/lib/urls'
  import Upload from '@/lib/upload'
  import {UPLOAD_TYPE, STATUS_CODE} from '@/lib/constants'
  import { defaultCoreCipherList } from 'constants';
  import { nameByConstMixin } from '@/lib/mixins'

  import pdf from 'vue-pdf'
  // import VueHtmlToPaper from 'vue-html-to-paper';

  export default {
    mixins: [nameByConstMixin],
    name: 'consult-pharm-content',
    props: ['note_id', 'note_status'],
    data () {
      return {
        note: {},
        replies : [],
        my_reply : {},
        user : {},
        buttonname : "전송",
        image_yn : false, //청구서
        image_receipt_yn : false, //계산서
        image_doc_yn : false, //추가서류
        receipt_img_view: '',
        doc_img_view: '',
        document_code_name: '',
        user_on : false,  //고객정보 더보기
        info_on : false,  //신청정보 자세히
        show_review: false,
        is_review: false,
        is_review_reply: false,
        is_submit: false,
        note_yn: 'Y',
        no_img: false,
        is_click: true,
        is_id_img: false,
        is_reattach_img: false,
        is_fax: null, //약국에 팩스 전송 kjw 20200805
        is_template: false, //템플릿 modal 팝업 오픈 여부
        tab_no: 1, //처방전, 계산서/진단서 탭
      }
    },
    computed: {
      ...mapState(['account']),
      // compoundProperty() { // id와 status 둘다 변경사항 체크 시 (일단 사용하지 않음) ... 20201202 kjw
      //   // `.join()` because we don't care about the return value.
      //   return [this.note_id, this.note_status].join()
      // }  
    },
    methods: {
      sendCancel() {
        this.$emit('onCancel', this.note);
      },
      async forcePayment() { // 관리자 수동 결제완료 처리
        await this.axios({
          method: 'post',
          url: '/consult_pharm/force_payment/' + this.note.note_id,
        }).then((response) => {
          // console.log('------------2');
          // console.log(response);
          // console.log('------------2');
          alert('결제 완료 변경 되었습니다.');
          this.$emit('setCancel', 4);
        }).catch((error) => {
          console.log('error!: ', error);
        });
      },
      print () {
      // Pass the element id here
      // this.$htmlToPaper('subpage');
        // window.print(document.getElementById('subpage'))

        let mywindow = window.open('', 'PRINT', 'left=0, top=0, width=800, height=1000, toolbar=0, scrollbars=0, status=0');

        mywindow.document.write('<html>');
        mywindow.document.write(' <head>');
        mywindow.document.write('   <title>처방전 by MDtalk</title>');
        mywindow.document.write('   <style type="text/css">');
        mywindow.document.write('     #img-url {width: 100%}');
        mywindow.document.write('   </style>');
        mywindow.document.write(' </head>');
        mywindow.document.write(' <body >');
        mywindow.document.write('   <div style="width:21cm; height: 26cm;">');
        mywindow.document.write(      document.getElementById('subpage').innerHTML);
        mywindow.document.write('   </div>');
        mywindow.document.write(' </body>');
        mywindow.document.write('</html>');

        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/
        
        window.setTimeout(function () {
          mywindow.print();
          mywindow.close();
        }, 500);

        return true;
      },
      noImg() {
        if(!this.no_img && this.is_fax) this.is_fax = false;
      },
      async reqDocImg() {
        // 하나도 선택 안 할 시 외 그대로 클릭했을 시에도 요청서류 체크 kjw 20200608
        // if(!this.is_id_img && !this.is_reattach_img) {
        if(this.note.is_id_img == this.is_id_img && this.note.is_reattach_img == this.is_reattach_img) {          
          alert('요청할 서류를 선택해 주세요');
          return;
        } else if(this.note.is_id_img && this.note.is_reattach_img) {
          // alert('증빙서류를 추가 요청할 수 없습니다.');
          return;
        }

        this.is_submit = true; //중복 방지 - 버튼 비활성화

        var params = {
            "note_id" : this.note.note_id,
            // "is_id_img" : this.is_id_img,
            // "is_reattach_img" : this.is_reattach_img
        }

        // 새로 클릭한 증빙서류만 요청 kjw 20200608
        if(!this.note.is_id_img && this.is_id_img) params.is_id_img = this.is_id_img;
        if(!this.note.is_reattach_img && this.is_reattach_img) params.is_reattach_img = this.is_reattach_img;

        let {data} = await this.axios.post(`/consult_note/update`, params);
        if (data.status === STATUS_CODE.OK) {
          this.note.is_id_img = this.is_id_img;
          this.note.is_reattach_img = this.is_reattach_img;
          alert("환자에게 증빙 첨부 요청 알림을 보냈습니다.");
        } else {
          alert("증빙 첨부 요청 시 오류가 발생했습니다.");
        }
        
        this.is_submit = false; //중복 방지 - 버튼 활성화
      },
      async sendDelete(delete_id) {
        const delete_params = {
          note_id: this.note_id,
          seq: delete_id
        }

        //console.log('delete_params', delete_params);
        // alert("삭제 : " + delete_id);
        if( confirm("답변을 삭제하시겠습니까?") ) {
          let {data} = await this.axios.delete(`consult_note`, {data: delete_params});
          if (data.status === STATUS_CODE.OK) {
            alert("답변이 삭제 되었습니다.");
            this.load_content(this.note_id);
          }  else {
            alert("삭제시 오류가 발생했습니다 : " + data.msg);
            return
          }
          
        } else {
          return
        }
      },
      async sendRestore(delete_id) {
        const delete_params = {
          note_id: this.note_id,
          seq: delete_id,
          delete_yn: 'N'
        }

        if( confirm("삭제된 답변을 다시 복원하시겠습니까?") ) {
          let {data} = await this.axios.delete(`consult_note`, {data: delete_params});
          if (data.status === STATUS_CODE.OK) {
            alert("답변이 복원되었습니다.");
            this.load_content(this.note_id);
          }  else {
            alert("복원시 오류가 발생했습니다 : " + data.msg);
            return
          }
          
        } else {
          return
        }
      },      
      get_user_type(u_type) {
        if(u_type==1) return '본인';
        else if(u_type==2) return '자녀';
        else if(u_type==3) return '부모';
        else return '';
      },
      handleOpen() {
        alert('test');
        this.$refs.myModal_TEL.scrollTop = this.$refs.myModal_TEL.scrollHeight
      },
      // next: function() {
      //   this.currentNumber += 1
      // },
      // prev: function() {
      //   this.currentNumber -= 1
      // },
      viewUserInfo() {
        this.user_on = !this.user_on
      },
      viewInfo() {  // 신청정보 자세히
        this.info_on = !this.info_on
      },
      selectImage(type){
        //console.log("selectImage().....")
        //this.$refs.fileInput.click()
        if(type == 1){
          this.$refs.fileInput1.click()
        }else if(type == 2){
          this.$refs.fileInput2.click()
        }else if(type == 3){
          this.$refs.fileInput3.click()
        }
      },
      async uploadImage(event){
        //console.log("uploadImage().....", event);

        var file_obj = event.target.files[0]

        // TODO 
        // key_id와 resize_width 현재값으로 보내는게 문제 없는지 체크
        // UPLOAD_TYPE 뭘로 해야되는지
        // let upload = new Upload(UPLOAD_TYPE.APP_IMG, {key_id:this.note_id, resize_width:400})
        let upload = new Upload(UPLOAD_TYPE.MSG_ATTACH, {key_id:this.note_id, resize_width:400})

        upload.append(file_obj);
        //console.log("uploadImage() file_obj", file_obj.name);

        let resp = await upload.done()

        var uploaded_file_url = resp.uploaded_files[0][1];

        //console.log("uploaded_file_url = " + uploaded_file_url);
        //console.log("uploaded_sm_file_url = " + uploaded_sm_file_url);

        /***************************************************/
        // TODO img_url은 내화면에 보이기위한 전체 URL
        // 주의 : URLS.WEB에 마지막에 "/"가 안붙어있음. 다른 url들은 붙어있음. 꼭 체크
        // upload를 msg 타입으로 하고 있음. 다른 타입으로 할 경우 url 변경 필요
        //this.my_reply.img_url = URLS.WEB + "/static/dr_web/msg/" + this.note_id + "/" + uploaded_file_url;
        this.my_reply.img_url = URLS.S3 + "static/dr_web/msg/" + this.note_id + "/" + uploaded_file_url;
        // this.my_reply.img_url = "https://images.mdtalk.io/node/prod/static/dr_web/msg/6422/6422_708f.pdf";

        // attach_url = 서버에 전송하기 위한 URL
        this.my_reply.attach_url = uploaded_file_url;
        this.my_reply.attach_name = file_obj.name;
        this.image_yn = true;
        // this.imageExist = true;
        // return resp.uploaded_sm_files;

      },
      async uploadImage2(event){
        var file_obj = event.target.files[0]
        let upload = new Upload(UPLOAD_TYPE.MSG_ATTACH, {key_id:this.note_id, resize_width:400})
        upload.append(file_obj);
        let resp = await upload.done()
        var uploaded_file_url = resp.uploaded_files[0][1];
        //this.my_reply.img_receipt_url = URLS.WEB + "/static/dr_web/msg/" + this.note_id + "/" + uploaded_file_url;
        this.my_reply.img_receipt_url = URLS.S3 + "static/dr_web/msg/" + this.note_id + "/" + uploaded_file_url;
        this.my_reply.attach_receipt_url = uploaded_file_url;
        this.my_reply.attach_receipt_name = file_obj.name;
        this.image_receipt_yn = true;
      },
      async uploadImage3(event){
        var file_obj = event.target.files[0]
        let upload = new Upload(UPLOAD_TYPE.MSG_ATTACH, {key_id:this.note_id, resize_width:400})
        upload.append(file_obj);
        let resp = await upload.done()
        var uploaded_file_url = resp.uploaded_files[0][1];
        //this.my_reply.img_doc_url = URLS.WEB + "/static/dr_web/msg/" + this.note_id + "/" + uploaded_file_url;
        this.my_reply.img_doc_url = URLS.S3 + "static/dr_web/msg/" + this.note_id + "/" + uploaded_file_url;
        this.my_reply.attach_doc_url = uploaded_file_url;
        this.my_reply.attach_doc_name = file_obj.name;
        this.image_doc_yn = true;
      },
      deleteImage(type){
        //console.log("deleteImage().....");
        if(type == 1){
          this.my_reply.img_url = null;
          this.my_reply.attach_url = "";
          this.my_reply.attach_name = "";
          this.image_yn = false;
        }else if(type == 2){
          this.my_reply.img_receipt_url = null;
          this.my_reply.attach_receipt_url = "";
          this.my_reply.attach_receipt_name = "";
          this.image_receipt_yn = false;
        }else if(type == 3){
          this.my_reply.img_doc_url = null;
          this.my_reply.attach_doc_url = "";
          this.my_reply.attach_doc_name = "";
          this.image_doc_yn = false;
        }
      },
      async sendComment () {
        //console.log('sendComment comment = ', this.my_reply.comment)
        let comment = this.my_reply.comment;
        if (!comment) comment = '처방 내용 확인 바랍니다.'; //return false;

        let attach_file = this.my_reply.attach_url;
        if(!this.no_img) {
          if(!attach_file) {
            alert('처방전 파일을 등록해 주세요');
            return false;
          } else if(!attach_file.includes('jpg') && !attach_file.includes('jpeg') && !attach_file.includes('png') && !attach_file.includes('gif') && !attach_file.includes('pdf')) {
            alert('처방전 파일은 jpg, jpeg, png, gif, pdf 파일을 등록할 수 있습니다.');
            this.deleteImage(1);
            return false;
          }
        }

        this.is_submit = true; //중복 방지 - 버튼 비활성화

        var params = {
            "note_id" : this.note.note_id,
            "dr_id" : this.account.dr_id,
            "comment" : comment,    
            "created_at" : moment().toString(),
            "attach_url" : this.my_reply.attach_url,
            "attach_name" : this.my_reply.attach_name,
            "note_status" : this.note.status
        }

        let {data} = await this.axios.post(`/consult_note_reply/`, params);

        if(data.status != "200") {
          alert(data.msg);
        } else {
          let reply_push = "처방전 도착. 약국에 보여주시고 약처방 받으세요. 종이/팩스 처방전을 요구할 수 있으니 약국에 미리 확인해 주세요.";
          
          if(this.no_img) reply_push = "병원 답변을 확인해 주세요.";
          else if(!this.no_img && this.is_fax) {
            if(!this.note.pharmacy_info.hosp_fax) {
              alert("병원 팩스번호를 등록 후 팩스를 다시 전송해 주세요. 엠디톡 관리자에게 문의!");
              return;
            }
            let fax_info = {
              //"document_url": URLS.WEB + "/static/dr_web/msg/" + this.note_id + "/" + this.my_reply.attach_url,
              "document_url": URLS.S3 + "static/dr_web/msg/" + this.note_id + "/" + this.my_reply.attach_url,
              "receiver_fax": this.note.pharmacy_info.pharmacy_fax,
              "receiver_name": this.note.pharmacy_info.pharmacy_name,
              "sender_fax": this.note.pharmacy_info.hosp_fax.replace(/-/gi, ''),
              "sender_name": this.note.sub_name

              // "document_url": "https://dr.mdsqr.com/static/dr_web/msg/1961/1961_8309.pdf",
              // "note_id": this.note_id,
              // "receiver_fax": this.note.pharmacy_info.pharmacy_fax,
              // "receiver_name": this.note.pharmacy_info.pharmacy_name,
              // "sender_fax": this.note.hosp_fax.replace(/-/gi, ''),
              // "sender_name": this.note.dr_name
            }

            //console.log('fax_info', JSON.stringify(fax_info));
            // return;

            // let token_info = "Token dsfijewifj3iir32jfidjfi333ijdg";
            let token_info = "Token 26c42293dd1fd5ed01320646e094196a827393f8";

            let headers_info = {
              'Content-Type' : 'application/json',
              // 'Accept': 'application/json',
              // 'WithCredentials': false,
              // 'Access-Control-Allow-Methods' : 'POST',
              // 'Access-Control-Allow-Headers' : '*',
              // 'Access-Control-Allow-Origin' : '*',
              // 'Access-Control-Allow-Headers' : '*',
              // 'Access-Control-Allow-Credentials' : true,
              'Authorization' : token_info
            }

            let today = new Date();
            let month = today.getMonth() + 1;  // 월
            let date = today.getDate();  // 날짜
            let secure_key = (month + date)*12;

            let {data} = await this.axios.post('https://api-v2.mdtalk.io/fax/'+secure_key+'/send/', fax_info, {headers: headers_info})
            
            if(!data.has_error) {
              // alert("등록한 문서를 팩스 전송하였습니다.");
              reply_push = "처방전 도착. 약국 팩스 전송 완료. 미수령시 병원에 문의 바랍니다.";
            } else {
              alert("팩스 전송에 실패하였습니다. 엠디톡 관리자에게 문의 후 다시 팩스 전송해 주세요.");
            }
          }

          let post_data = {
            push_title: `전화상담 알림\n(${this.account.dr_name})`, 
            push_msg: reply_push, 
            push_dr_id:this.account.dr_id, 
            push_uid:this.note.id,
            push_consult_type:9,
            push_send_type:3
          }

          let {data} = await this.axios.post(`consult_note/${this.note.note_id}/push`, post_data);

          // 후기 재촉 알림 push..... kjw 20201223
          reply_push = "전화처방 서비스에 만족하셨는지요? 후기를 남기시면 향후 진료비 결제에 사용하실 수 있는 포인트를 드립니다. 감사합니다.";
          post_data = {
            push_title: `엠디톡 알림`, 
            push_msg: reply_push, 
            push_dr_id:this.account.dr_id, 
            push_uid:this.note.id,
            push_consult_type:9,
            push_send_type:3
          }
          await this.axios.post(`consult_note/${this.note.note_id}/push`, post_data)
          // this.note_status = 5;
          alert(`처방전이 등록되었습니다. \n사용자가 엠디톡(MDtalk) 앱에서 확인할 수 있습니다.`);
        }

        // this.input_text = '' // 입력값 초기화
        //console.log("comment result = " , data);

        // 화면갱신
        await this.$emit('reload_list', 5);

        this.load_content(this.note.note_id);

        this.is_submit = false; //중복 방지 - 버튼 활성화

        return true;
      },
      async docUpload(type) {
        let attach_file = '';
        let attach_name = '';
        if(type == 1){
          attach_file = this.my_reply.attach_url; //청구서
          attach_name = this.my_reply.attach_url;
        }else if(type == 2){
          attach_file = this.my_reply.attach_receipt_url; //진료비 계산서
          attach_name = this.my_reply.attach_receipt_name;
        }else if(type == 3){
          attach_file = this.my_reply.attach_doc_url; //추가서류
          attach_name = this.my_reply.attach_doc_name;
        }

        if(!this.no_img) {
          if(!attach_file) {
            alert('파일을 등록해 주세요');
            return false;
          } else if(!attach_file.includes('jpg') && !attach_file.includes('jpeg') && !attach_file.includes('png') && !attach_file.includes('gif') && !attach_file.includes('pdf')) {
            alert('jpg, jpeg, png, gif, pdf 파일만 등록할 수 있습니다.');
            this.deleteImage(type);
            return false;
          }
        }
        this.is_submit = true; //중복 방지 - 버튼 비활성화

        let params = {
            "note_id" : this.note.note_id,
            "dr_id" : this.account.dr_id,
            "attach_url" : attach_file,
            "attach_name" : attach_name,
            "document_type": type, //서류구분(1-처방전, 2-계산서, 3-추가서류)
        }
        await this.axios({
          method: 'post',
          url: '/consult_document/upload/' + this.note.note_id,
          data: params,
        }).then((response) => {
          // console.log('------------1');
          // console.log(response);
          // console.log('------------1');
          
          let docName = '';
          if(type == 2){
            docName = '진료비 계산서';
          }else if(type == 3){
            docName = '추가서류';
          }

          if(response.data.status == '200'){
            let push_params = {
              push_title: `서류발급 알림`, 
              push_msg: docName + ' 발급 완료 되었습니다.',
              push_dr_id: this.account.is_admin == 1 ? this.account.dr_id : this.note.sub_id, 
              push_uid: this.note.id,
              push_consult_type: 9,
              push_send_type: 3
            }
            
            this.axios({
              method: 'post',
              url: '/consult_note/' + this.note.note_id + '/push',
              data: push_params,
            }).then((response) => {
              // console.log('------------2');
              // console.log(response);
              // console.log('------------2');
              alert('서류 발급이 완료되어 환자에게 알림이 전송 되었습니다.');
            }).catch((error) => {
              console.log('error!: ', error);
            });
          }else{
            alert('서류 업로드 시 오류가 발생 하였습니다.');
          }
        }).catch((error) => {
            console.log('error!: ', error);
        });

        // if(type == 2){
        //   this.receipt_img_view = URLS.WEB + "/static/dr_web/msg/" + this.note_id + "/" + attach_file;
        // }else if(type == 3){
        //   this.doc_img_view = URLS.WEB + "/static/dr_web/msg/" + this.note_id + "/" + attach_file;
        // }

        // 화면갱신 필요한가 ?
        //await this.$emit('just_reload');
        //await this.$emit('reload_list', 5);
        this.load_content(this.note.note_id);
        this.is_submit = false; //중복 방지 - 버튼 활성화
        return true;
      },
      async img_click(url) { 
        // const url = this.note.attach_url;
        // console.log("url = " + url);
        // let img_detail = window.open(url,"img_detail","width=800,height=600");
        let routeData = this.$router.resolve(`/imageview?image_url=${url}`);
        this.popupCenter(routeData.href, "image_view", 600, 800, 0, 200);
        
      },
      pdf_click(url) { 
        // console.log("url = " + url);
        let img_detail = window.open(url,"pdf_detail","width=1000,height=1000");
      },
      async load_content(note_id){
        this.replies = [];
        this.note = {};
        this.my_reply = {};
        this.user = {};
        this.buttonname = "전송";
        this.image_yn = false;
        this.image_receipt_yn = false; //계산서
        this.image_doc_yn = false; //추가서류
        this.no_img = false;
        this.is_fax = null;
        this.receipt_img_view = '';
        this.doc_img_view = '';
        this.document_code_name = '';

        if(this.$refs.fileInput != undefined){
          this.$refs.fileInput.value = "";
        }

        let params = {
          is_admin: this.account.is_admin,
          is_doctor: 1,
        }

        // console.log('params', params)

        let { data } = await this.axios.get(`consult_pharm/${note_id}`, {params: params})

        if(data.status == "200"){
          let {resp} = data;

          // console.log(resp);

          if(resp){
            var note = Object.assign({}, this.note, resp[0]);

            this.note = note;

            // user 정보조회
            let uid = note.id;
            let {data} = await this.axios.get(`user/${uid}/health`)
            if (data.status == "200") {
              let {resp} = data
              this.user = resp;
              //this.user.birthday = moment(this.user.birthday).format('YYYY년 MM월 DD일');
              //this.user.sex = (this.user.sex === 'M') ? '남자' : '여자';
              //this.user.is_drinking = (this.user.is_drinking) ? '가끔(주1회미만)' : '자주(주2회이상)';
              //this.user.is_smoking = (this.user.is_smoking) ? '흡연' : '비흡연';
            } else {
              //console.log("user health data.status = " + data.status + ", msg = " + data.msg);
              this.user = {};
            }

            let params = {
              note_id: this.note_id,
              is_attach_file: true
            }

            // console.log('params', params)
            let replay_data = await this.axios.get(`consult_note_reply`, {params: params})
            
            if (replay_data.data.status == "200") {
              let {resp} = replay_data.data;
              // console.log('resp', resp[0].attach_url)

              resp.img_url = URLS.S3 + "static/dr_web/msg/" + this.note_id + "/" + resp[0].attach_url.replace('_original.pdf', '_raw.pdf');
              if(resp[0].dr_attach_file){
                resp.img_url = resp[0].dr_attach_file.file_original;
              }
              // resp.img_url = URLS.S3 + "static/dr_web/msg/1966/1966_b0cb.jpg" //테스트용 img 파일
              // resp.img_url = URLS.S3 + "static/dr_web/msg/1966/test.pdf" //테스트용 pdf 파일
              // resp.img_url = "https://s3.ap-northeast-2.amazonaws.com/image.mdtalk.io/node/prod/static/dr_web/msg/1446/1446_bbfe.pdf" //테스트용 pdf 파일

              // console.log('resp.img_url', resp.img_url)
              this.replies.push(resp);

            } else {
              this.replies = [];
            }
          }
        } else {
          alert(data.msg);
        }
        // console.log("replies.length = " + this.replies.length);
        // console.log('this.replies: ', this.replies);
      },
    },
    async mounted () {
        //console.log('consultnotecontent 마운트됨!')
        // this.$log.debug('now', moment().toString())
        // this.$log.debug('created', this.note.created_at)
        if(this.note_id) this.load_content(this.note_id)
    },
    watch: {
      note_id: function (note_id) {
      //  console.log('telContent note_id 변경됨(watch)', note_id)
        this.load_content(note_id)
      },
      note_status: function (note_status) {
      //  console.log('telContent note_status 변경됨(watch)', note_status)
        this.note.status = note_status;
      },
      // compoundProperty(prop) { // id와 status 둘다 변경사항 체크 시 (일단 사용하지 않음) ... 20201202 kjw
      //   let arr_prop = prop.split(',');
      //   console.log('telContent compoundProperty 변경됨(watch)', arr_prop[0]);
      //   console.log('telContent compoundProperty 변경됨(watch)', arr_prop[1]);
      // },
    },
    components: {
      pdf
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  input:focus::-webkit-input-placeholder, textarea:focus::-webkit-input-placeholder { /* WebKit browsers */ color:transparent; } 
  input:focus:-moz-placeholder, textarea:focus:-moz-placeholder { /* Mozilla Firefox 4 to 18 */ color:transparent; } 
  input:focus::-moz-placeholder, textarea:focus::-moz-placeholder { /* Mozilla Firefox 19+ */ color:transparent; } 
  input:focus:-ms-input-placeholder, textarea:focus:-ms-input-placeholder { /* Internet Explorer 10+ */ color:transparent; }

  img {
    image-orientation: from-image;
  }

  .medical-history > div {
    margin-bottom: 20px;
  }

  .medical-history h3 {
    color: #4c4c4c;
    margin-bottom: 10px;
    letter-spacing: -.5px;
    font: 500 16px 'Noto Sans KR', sans-serif;
  }

  .history-txt {
    width: 100%;
    padding: 12px 15px;
    box-sizing: border-box;
    background-color: #f5f6fa;
    font: 400 12px 'Noto Sans KR', sans-serif;
    min-height: 50px;
    word-wrap: break-word;
    word-break:keep-all;
  }
  .history-txt .cur-img{
    margin-right: 20px;
    text-align:left;
  }
  .history-txt .tot-img{
    margin-left: 110px;
    text-align:right;
  }
  .history-txt .change-img{
    cursor: pointer;
    text-align:left;
  }
  .history-txt .change-img-o{
    color: #f5f6fa;
    text-align:left;
  }
  
  .history-img {
    text-align: center;
    width: 200px;
    /* height: 300px; */
    /* margin-top: 10px; */
    background-color: #f5f6fa;
    min-height: 200px;
    transform: translateX(0px);
  }

  .history-client-list ul,
  .history-before-list ul{float: left;}

  .history-client-list li,
  .history-before-list li{
    margin-bottom: 10px;
    height: 20px;
    font: 400 12px 'Noto Sans KR', sans-serif;
  }

  .history-client-list .client-lt,
  .history-before-list .before-lt{
    width: 120px;
    color: #b7b7b7;
  }

  .history-client-list .client-rt,
  .history-before-list .before-rt{
    width: 200px;
    color: #484848;
  }

  .rt-chat-input-wrap {
    width: 90%;
    height: 140px;
    padding: 15px 80px 15px 15px;
    box-sizing: border-box;
    position: relative;
    background-color: #f5f6fa;
  }

  .rt-chat-input-wrap > textarea {
    width: 95%;
    height: 100%;
    border: none;
    outline: 0;
    /* background-color: transparent; */
    resize : none;
  }

  .rt-chat-input-wrap > button {
    outline: 0;
    cursor: pointer;
    border: none;
    padding: 0;
    position: absolute;
  }

  .chat-btn {
    color: #fff;
    width: 50px;
    height: 30px;
    right: 20px;
    top: 20px;
    box-sizing: border-box;
    text-align: center;
    background-color: #5e71e9;
    font: 400 12px/30px 'Noto Sans KR', sans-serif;
  }

  /**********************************************/
  .note-title {
    color: #b7b7b7;
    margin-bottom: 10px;
    height: 20px;
    font: 400 12px 'Noto Sans KR', sans-serif;
  }
  .note-content {
    vertical-align: middle;
    color: #484848;
  }


  /**********************************************/
  /** 
    * 이미지 업로드
    */
  .thumbnail {
    /*padding:4px;*/
    border: 1px solid #ddd;
    display: inline-block;
    float:left;
    overflow: hidden;
    /* position:relative; */
    line-height: 0;
    cursor: pointer;
  }

  .thumbnail img {
    width: 150px;
    height: 200px;
  }

  /*   
  .thumbnail img {
    width: 100px;
    height: 100px;
  }

  .thumbnail-btn {
    display: inline-block;
    float:left;
    overflow: hidden;
    position:relative;
    padding: 6px 12px;
    border:1px solid #ddd;
    margin: 5px 0 0 10px;
    background-color: #bbb;
    border-radius: 10px;
    line-height: 25px;
    color: #fff;
  } 
  */

  .thumbnail-btn a {
    font-weight:bold;
    display: block;
    /*width: 100px;*/
    width: 100%;
    height: 100%;
    font-size: 12px;
    cursor: pointer;
  }

  .add-interior-thumb {font-size: 0;}
  .add-interior-thumb span {
    float: left;
    width: 120px;
    margin: 5px 0 0 0;
  }

  .add-interior-thumb .signup-notice {
    float: left;
    width: 150px;
    margin: 5px 0 0 0;
  }

  .add-interior-thumb p {
    float: left;
    width: 40px;
    margin: 5px 0 0 0;
  }

  .add-interior-thumb .btn-submit{
    width:55px;
    height:25px;
    line-height:27px;
    padding:0;
    margin:5px;
    border:0;
    color:#777;
    font-weight:bold;
    cursor:pointer;
  }

  .btn-submit{
    width:55px;
    height:25px;
    line-height:27px;
    padding:0;
    margin:5px;
    border:0;
    color:#777;
    font-weight:bold;
    cursor:pointer;
  }

  .add-interior-thumb-upload {
    display: inline-block;
    width: 120px;
    height: 90px;
    border: none;
    position: relative;
    border: 1px solid #999;
    background-color: transparent;
  }

  .add-interior-thumb-upload span {
    display: block;
    width: 35px;
    height: 35px;
    color: #999;
    position: absolute;
    text-align: center;
    left: 50%;
    top: 50%;
    border-radius: 50%;
    border: 1px solid #999;
    transform: translate(-50%, -50%);
    font: 400 24px/35px 'Noto Sans KR', sans-serif;
  }
  /* 2019-08-09 추가 sh */
  .guest-info{
    margin-bottom:10px;
  }
  .guest-info-l{
    margin-bottom:10px;
  }
  .guest-info dt,
  .guest-info dd{
    font:400 12px Noto Sans KR,sans-serif;
    min-height:20px;
    margin-bottom:3px;
  }
  .guest-info-l dt,
  .guest-info-l dd{
    font:400 12px Noto Sans KR,sans-serif;
    min-height:20px;
    margin-bottom:3px;
  }
  .guest-info dt{
    float:left;
    width:90px;
    margin-right:10px;
    color:#b7b7b7;
  }
  .guest-info-m dt{
    float:left;
    width:150px;
    margin-right:10px;
    color:#b7b7b7;
  }
  .guest-info-l dt{
    float:left;
    width:300px;
    margin-right:10px;
    color:#b7b7b7;
  }
  .guest-info, .guest-info-m, .guest-info-l  dd{
    overflow:hidden;
    color:#484848;
  }
  .guest-info .data-info{
    display:inline-block;
    width:50%;
    vertical-align:top;
  }
  .answer{
    margin:0 10px 10px;
  }
  .answer .note-tt,
  .answer h4{
    margin-bottom:10px;
    font-weight:bold;
  }
  .answer .note-tt .name, .answer .note-tt .date{
    font:400 12px Noto Sans KR,sans-serif;
  }
  .answer .note-tt .name2{
    font:400 12px Noto Sans KR,sans-serif;
  }
  .answer .note-tt .name2 .docName{
    color: blue;
  }
  .answer .note-tt .date{
    float:right;
  }
  .answer .note-cont{
    padding:10px;
    background:#f5f6fa;
    text-align:right;
  }
  .answer .note-cont textarea{
    display:block;
    width:100%; 
    height:120px;
    padding:10px;
    font:400 12px Noto Sans KR,sans-serif;
    text-align:left;
    word-break:keep-all;
    box-sizing:border-box;
    -webkit-box-sizing:border-box;
  }
  .answer .note-cont .btn-submit{
    width:60px;
    height:30px;
    line-height:32px;
    padding:0;
    margin:0;
    border:0;
    background:#5e71e9;
    color:#fff;
    font-weight:bold;
    cursor:pointer;
  }
  .answer .note-cont .history-txt{
    text-align:left;
    padding:0px 10px;
    min-height:0;
    word-break:keep-all;
  }
  /* .answer .upload-img{
    margin-top: 10px;
  } */

  .signup-notice {
    text-align:left;
    color: #afafaf;
    margin: 0;
    font: 400 12px 'Noto Sans KR', sans-serif;
  }

  .signup-notice-pre {
    text-align:left;
    width: 60px;
    color: #afafaf;
    margin: 0;
    font: 400 12px 'Noto Sans KR', sans-serif;
  }

  .signup-notice-red {
    text-align:left;
    color: #ee0000;
    /* margin: 0; */
    font: 400 11px 'Noto Sans KR', sans-serif;
  }

  .signup-notice-red-bottom {
    text-align:left;
    color: #ee0000;
    margin-bottom: 15px;
    font: 400 14px 'Noto Sans KR', sans-serif;
  }

  .signup-notice-blue {
    text-align:left;
    color: #0000ee;
    /* margin-left: 100px; */
    font: 400 12px 'Noto Sans KR', sans-serif;
  }

  .img-area{
    margin-top:-10px;
    padding:0px 15px;
    background:#f5f6fa;
  }
  
  .user-info-btn {
    float: right;
    padding: 5px;
    cursor:pointer;
    position: relative;
    box-sizing: border-box;
    font: 400 12px 'Noto Sans KR', sans-serif;       
  }

  .submit-btn {
    width:70px;
    height:25px;
    line-height:32px;
    padding:0;
    margin-left:10px;
    border:0;
    background:#5e71e9;
    font: 400 12px 'Noto Sans KR', sans-serif;
    color:#fff;
    /* font-weight:bold; */
    cursor:pointer;
  }  

  .etc-btn {
    float: right;
    padding: 2px 5px;
    cursor:pointer;
    /* position: relative; */
    border: 1px solid #aaa;
    background:#ccc;
    font: 400 12px 'Noto Sans KR', sans-serif;   
  }

  /* The Modal (background) */
  .modal {
    display: block; /* Hidden by default */
    position: fixed; /* Stay in place */
    opacity:0.99;
    z-index: 100; /* Sit on top */
    padding-top: 80px; /* Location of the box */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(9,9,9); /* Fallback color */
    background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
  }

  /* Modal Content */
  .modal-content {
    position: relative;
    background-color: #fefefe;
    margin: auto;
    padding: 0;
    border: 1px solid #888;
    width: 350px;
    overflow-y: auto;
    /* overflow: hidden; */
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);
    -webkit-animation-name: animatetop;
    -webkit-animation-duration: 0.4s;
    animation-name: animatetop;
    animation-duration: 0.4s
  }

  /* Add Animation */
  @-webkit-keyframes animatetop {
    from {top:-300px; opacity:0} 
    to {top:0; opacity:1}
  }

  @keyframes animatetop {
    from {top:-300px; opacity:0}
    to {top:0; opacity:1}
  }

  /* The Close Button */
  .close {
    color: white;
    float: right;
    font-size: 30px;
    font-weight: bold;
  }

  .close:hover,
  .close:focus {
    color: #000;
    text-decoration: none;
    cursor: pointer;
  }

  .modal-header h1 {
    margin-bottom: 10px;
    font: 400 18px 'Noto Sans KR', sans-serif;
  }

  .modal-header {
    padding: 10px 20px;
    background-color: #111;
    color: white;
  }

  .modal-body {padding: 10px 20px;}

  .modal-footer {
    padding: 2px 10px;
    background-color: #111;
    color: white;
  }

  .img-chk {
    float: right;
    color: #333;
    /* margin-top: 50px; */
    margin-top: 10px;
    font: 400 12px 'Noto Sans KR', sans-serif;
  }

  .img-chk > input {
    margin-left: 15px;
  }

  .btn-confirm {
    float: right;
    width:60px;
    height:30px;
    line-height:32px;
    padding:0;
    margin-right:10px;
    border:0;
    background:#5e71e9;
    font: 400 12px 'Noto Sans KR', sans-serif;
    color:#fff;
    /* font-weight:bold; */
    cursor:pointer;
  }

  .btn-cancel {
    float: right;
    width:60px;
    height:30px;
    line-height:32px;
    padding:0;
    /* margin-right:10px; */
    border:0;
    background:#999;
    font: 400 12px 'Noto Sans KR', sans-serif;
    color:#fff;
    /* font-weight:bold; */
    cursor:pointer;
  }


  .tabs .tab {
    width: 100%;
    height: 40px;
    font-size: 0;
    box-sizing: border-box;
    border-bottom: 1px solid #e7e7e9;
    margin-bottom: 10px;
  }

  .tabs .tab > li {
    color: #b8b8b8;
    width: 50%;
    /* width: 50%; */
    height: 40px;
    cursor: pointer;
    display: inline-block;
    text-align: center;
    box-sizing: border-box;
    font: 500 14px/40px 'Noto Sans KR', sans-serif;
  }

  .tabs .tab > li:hover,
  .tabs .tab .select {
    color: #736ee6;
    position: relative;
  }

  .tabs .tab > li:hover::after,
  .tabs .tab .select::after {
    content: '';
    display: block;
    width: 100%;
    height: 3px;
    position: absolute;
    bottom: 0;
    background-color: #736ee6;
  }

  /* 계산서/진단서탭 관련 CSS */
  /* .upload{
    margin:0 10px 10px;
  } */
  .upload .note-cont{
    padding:10px;
    background:#f5f6fa;
    text-align:right;
  }
  .upload .note-cont .btn-submit{
    width:60px;
    height:30px;
    line-height:32px;
    padding:0;
    margin:0;
    border:0;
    background:#5e71e9;
    color:#fff;
    font-weight:bold;
    cursor:pointer;
  }

  .upload .img-area{
    margin-top:10px;
    padding:10px 15px;
    background:#f5f6fa;
  }

  .upload .note-tt{
    margin-top:20px;
    margin-bottom:10px;
  }
</style>

